import React from 'react'

import Emoji from 'components_new/atoms/Emoji'

import { useTranslation } from 'language/translator'
import { useAccountSettings } from 'redux/hooks/SignedInAccount'

export function useWelcomeTitle() {
  const { t } = useTranslation()
  const { account } = useAccountSettings()
  const hours = new Date().getHours()

  if (hours < 12) {
    return (
      <>
        {t('home', 'good_morning')}, {account?.first_name}
        <Emoji name="coffee" style={{ marginLeft: '0.2em' }} />
      </>
    )
  } else if (hours < 18) {
    return (
      <>
        {t('home', 'good_afternoon')}, {account?.first_name}
        <Emoji name="wave" style={{ marginLeft: '0.2em' }} />
      </>
    )
  } else if (hours < 22) {
    return (
      <>
        {t('home', 'good_evening')}, {account?.first_name}
        <Emoji name="star" style={{ marginLeft: '0.2em' }} />
      </>
    )
  } else {
    return (
      <>
        {t('home', 'good_night')}, {account?.first_name}
        <Emoji name="crescent_moon" style={{ marginLeft: '0.2em' }} />
      </>
    )
  }
}
